import * as React from 'react'
import { AddPaymentMethodDialog } from '../../../Payments/AddPaymentMethodDialog/AddPaymentMethodDialog'
import { ENTITY_TYPES } from '@sales-center/common'
import { ViewPaymentMethodsDrawer } from '../../../Payments/ViewPaymentMethodsDrawer/ViewPaymentMethodsDrawer'
import { OppStatus } from '../../../Opportunities/OpportunityCard/typings'
import { LEAD_STATUSES } from '../../../Leads/LeadCard/typings'
import { ClosingRequirement } from '../../ClosingRequirement'
import { PaymentIconV2 } from '@sales-center/components'
import { useData } from './hooks/useData'
import { useHandlers } from './hooks/useHandlers'

export type Props = {
  count: number
  entityId: number
  entityType: ENTITY_TYPES
  isComplete: boolean
  leadStatus?: LEAD_STATUSES
  locationId: string
  billToId: string
  oppStatus?: OppStatus
  canUpdate: boolean
}

export function PaymentRequirements(props: Props) {
  const {
    count,
    entityId,
    entityType,
    isComplete,
    locationId,
    billToId,
    canUpdate,
  } = props

  const { isDisabled, disabledText } = useData(props)
  const {
    openAddDrawer,
    closeAddDrawer,
    addDrawerOpen,
    closeViewDrawer,
    viewDrawerOpen,
  } = useHandlers()

  return (
    <>
      <ClosingRequirement
        entityId={entityId}
        count={count}
        title="Payment"
        buttonText="Capture Card"
        linkText="Cards Captured"
        isComplete={isComplete}
        isDisabled={isDisabled}
        isDisabledText={disabledText}
        icon={<PaymentIconV2 />}
        buttonClick={openAddDrawer}
        requirement="payment"
      />

      <AddPaymentMethodDialog
        entityId={entityId}
        entityType={entityType}
        locationId={locationId}
        onClose={closeAddDrawer}
        open={addDrawerOpen}
      />

      <ViewPaymentMethodsDrawer
        entityId={entityId}
        entityType={entityType}
        locationId={locationId}
        billToId={billToId}
        onClose={closeViewDrawer}
        open={viewDrawerOpen}
        canUpdate={canUpdate}
      />
    </>
  )
}
